<template>
  <div class="content-item flex">
    <div class="content-item-label">
      <span v-if="JSON.parse(commonData[0].value)==='1'" class="red">*</span>{{ JSON.parse(commonData[1].value) }}
    </div>
    <el-radio-group v-model="radio" class="flex align-items-center">
      <el-radio :label="1">是</el-radio>
      <el-radio :label="0">否</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "IsRx",
  props: ['rxType', 'commonData'],
  computed: {
    radio: {
      get() {
        return this.rxType
      },
      set(val) {
        this.$emit('update:rxType',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

